import {PlayArrow} from '@mui/icons-material';
import {Button, Paper, Stack, Typography, Box} from '@mui/material';
import ExerciseSessionActive from './ExerciseSessionActive';

export interface ExerciseSessionProps {
  onStartSession: () => void;
}

export default function ExerciseSession({onStartSession}: ExerciseSessionProps) {
  const handleStartNewSession = () => {
    onStartSession();
  };

  return (
    <Stack gap={3}>
      {/* Always show the start new session section */}
      <Paper sx={{p: 4, textAlign: 'center', bgcolor: 'primary.main', color: 'white'}}>
        <Typography variant="h5" sx={{fontWeight: 600, mb: 2, color: 'white'}}>
          Ready to Study?
        </Typography>
        <Typography variant="body1" sx={{mb: 3, opacity: 0.9, color: 'white'}}>
          Start a new study session and practice your selected topics
        </Typography>
        <Box sx={{display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap'}}>
          <Button
            variant="contained"
            size="large"
            startIcon={<PlayArrow />}
            onClick={handleStartNewSession}
            sx={{
              bgcolor: 'white',
              color: 'primary.main',
              '&:hover': {
                bgcolor: 'grey.100',
              },
            }}
          >
            Start Study Session
          </Button>
        </Box>
      </Paper>

      {/* Show active sessions section if there are any */}
      <ExerciseSessionActive />
    </Stack>
  );
}
